export enum BillingConfigurationType {
  BilledByIssuer = 'BilledByIssuer',
  External = 'External',
}

export class BillingConfiguration {
  type: BillingConfigurationType;

  constructor(json: any) {
    this.type = json.type;
  }
}
